import React from "react";
import { formatPrice } from "../utils/format";
import { rowKey } from "../utils/catalogGrouping";
import SupplierRow from "./SupplierRow";

const CatalogItem = ({ group, isExpanded, onToggle, priceBasis, rowQuantities, onQuantityChange, onAddRow }) => (
    <div className="pc-item">
        <div className="pc-item-row" onClick={onToggle}>
            <div className="pc-item-icon">▢</div>
            <div className="pc-item-main">
                <div className="pc-item-name">{group.name}</div>
                <div className="pc-item-meta">{group.rows.length} поставщик{group.rows.length === 1 ? "" : "ов"}</div>
            </div>
            <div className="pc-item-price">
                <span className="pc-price-label">от</span>
                <span className="pc-price-value">{formatPrice(group.minPrice)} ₽</span>
            </div>
            <div className="pc-chevron">{isExpanded ? "▲" : "▼"}</div>
        </div>
        {isExpanded && (
            <div className="pc-suppliers">
                {group.rows.map((row) => (
                    <SupplierRow
                        key={rowKey(row)}
                        row={row}
                        priceBasis={priceBasis}
                        quantity={rowQuantities[rowKey(row)] || 1}
                        onQuantityChange={(value) => onQuantityChange(row, value)}
                        onAdd={() => onAddRow(row)}
                    />
                ))}
            </div>
        )}
    </div>
);

export default CatalogItem;
